import { ImageServerHelper } from '../../shared/services/ImageServerHelper';

/**
 * Creates a configuration object. For internal use only; use the UScopeLauncher
 * @param userVm
 * @returns {{features: {snapshotMode: string, showUDI: boolean, dscEnabled: boolean, linkToImage: boolean, annotAutoSaveEnabled: boolean}, toolbarOptions: {resizeBtn: boolean, nextPrevSlide: boolean, dscSetupBtn: boolean, snapshotBtn: boolean, autoRaster: boolean, openImageScopeBtn: boolean, openPDNBtn: boolean}, extensions: {'us:imagescope-launcher': {filename: string, urlGenerator: string}}, images: *[], overlays: {toolbar: boolean, zoombar: boolean, thumbnail: boolean, heatMap: boolean, rotation: boolean, label: boolean, none: boolean, magnifier: boolean, scalebar: boolean}, setup: {readonly userName: *, readonly userid: *, divId: string}}|*}
 */
export function create (userVm) {
  return {
    setup: {
      divId: 'uscope', // mount point for uScope
      get userid () { return userVm?.userId; },
      get userName () { return userVm?.fullName; }
    },
    toolbarOptions: {
      openImageScopeBtn: true,
      dscSetupBtn: true, // HasRolePermission('Conferencing', 'Initiate');
      resizeBtn: false,
      openPDNBtn: true,
      snapshotBtn: true,
      autoRaster: true,
      nextPrevSlide: true
    },
    overlays: {
      label: true, // HasRolePermission('Image', 'ViewLabel');
      magnifier: true,
      thumbnail: true,
      scalebar: true,
      zoombar: true,
      rotation: true,
      heatMap: true,
      toolbar: true,
      none: false // ?
    },
    extensions: {
      'us:imagescope-launcher': {
        urlGenerator: 'generatePathToSisFileForImageId',
        filename: 'DigitalSlides.sis'
      }
    },
    features: {
      annotAutoSaveEnabled: true,
      dscEnabled: true,
      linkToImage: false,
      snapshotMode: 'printViewport', // TODO: Still needed?
      showUDI: true
    },
    images: [] // populate with images to show in uScope when it starts
  };
}

/**
 * Manages a config object. For internal use only; use the UScopeLauncher
 * @param config
 * @param authVm
 * @param imageServerHelper
 * @returns {{configureImageServers(*=): void, setImageGroup(*): void, setRenderer(*): void, setImageDefaults(*=): void, addImage: addImage}}
 */
export function createUScopeConfigEditor (config, authVm, imageServerHelper) {
  const imageDefaults = { mag: 'Fit' };
  let imageGroup = config.images;
  if (!imageServerHelper) {
    imageServerHelper = new ImageServerHelper();
  }

  return {
    configureImageServers (servers) {
      imageServerHelper.configureImageServers(servers);
    },

    setImageDefaults (defaults) {
      Object.assign(imageDefaults, defaults);
    },

    setRenderer (Renderer) {
      config.setup.Renderer = Renderer;
    },

    setImageGroup (images) {
      imageGroup = images;
    },

    addImage: (image, slideId = 1, specimenId = 1) => {
      let { baseUrl, imageIdOrPath } = imageServerHelper.getImageInfo(image);
      let filePath = '';
      let imageId;
      if (typeof imageIdOrPath === 'string') {
        filePath = imageIdOrPath;
      } else {
        imageId = imageIdOrPath;
      }

      if (authVm?.bearerToken) { // note: currently uScope does not support path with auth token
        baseUrl = `${baseUrl}/@@${authVm.bearerToken}/@${imageIdOrPath}`;
      } else { // note: image id's are not supported without an auth token
        baseUrl = `${baseUrl}/${imageIdOrPath}`;
      }

      imageGroup.push({
        id: slideId,
        imageId,
        filePath,
        fullURL: baseUrl,
        itemId: slideId,
        positionIndex: imageGroup.length,
        mag: imageDefaults.mag,

        thumbnailImageSrc: `${baseUrl}?0+0+0+0+-4+80+S+0`,
        thumbnailLabelSrc: `${baseUrl}?0+0+0+0+-2+80+S+0`,

        group: {
          title: '',
          id: specimenId
        },
        slideId,
        memo: '',
        SaveAnnotation: true,
        info: null
      });
    }
  };
}
